import { Grid } from '@material-ui/core';
import en from '../../../../lang/en-us';
import { CheckBoxField } from '../../../../lib/CheckBoxField';
import DatePickerInput from '../../../../lib/DatePicker';
import TextInput from '../../../../lib/TextField';
import { getDateString } from '../../../../utils/constants';
import { ProfileEvent, useProfileInfo } from './profile-context';
import { ObjectiveDetail } from './utils';

const { dashboard } = en;

const RenderCheckBoxFields = () => {
    const { state: profileState, dispatch } = useProfileInfo();
    const { objective } = profileState;
    const handleChange = (key: keyof typeof ObjectiveDetail, checked: boolean) => {
        dispatch({
            payload: (checked ? key : ObjectiveDetail.None) as ObjectiveDetail,
            action: ProfileEvent.SetObjectiveType,
        });
        if ((key as ObjectiveDetail) === ObjectiveDetail.DOB) {
            dispatch({
                action: ProfileEvent.SetObjectiveValue,
                payload: '',
            });
        }
    };
    return (
        <>
            {(Object.values(ObjectiveDetail) as Array<keyof typeof ObjectiveDetail>).map(
                (key, index) => {
                    return (
                        <CheckBoxField
                            onChange={(e) => handleChange(key, e.target.checked)}
                            label={key}
                            value={objective.type === key}
                        />
                    );
                },
            )}
        </>
    );
};

export const ObjectiveDetails = () => {
    const { state: profileState, dispatch: profileDispatch } = useProfileInfo();
    const selectedOptionIsNone = profileState.objective.type === ObjectiveDetail.None;
    return (
        <>
            <p className="details-heading"> Please select any one of the below parameters </p>
            <div className="render-fields">
                <RenderCheckBoxFields />
            </div>
            <Grid container spacing={2} className="grid-gap">
                <Grid item xs={12} md={4}>
                    {profileState.objective.type === ObjectiveDetail.DOB ? (
                        <DatePickerInput
                            className="sip-date-input"
                            label="Date of Birth"
                            value={
                                profileState.objective.value
                                    ? new Date(profileState.objective.value)
                                    : null
                            }
                            disableFuture={true}
                            disablePast={false}
                            onChange={(e) => {
                                profileDispatch({
                                    action: ProfileEvent.SetObjectiveValue,
                                    payload: e ? getDateString(e) : '',
                                });
                            }}
                        />
                    ) : (
                        <TextInput
                            value={profileState.objective.value}
                            variant="filled"
                            className="filled-input-inactive"
                            disabled={
                                profileState.objective.type === ObjectiveDetail.None ||
                                !profileState.objective.type
                            }
                            onChange={(e) => {
                                profileDispatch({
                                    action: ProfileEvent.SetObjectiveValue,
                                    payload:
                                        profileState.objective.type === ObjectiveDetail.PAN
                                            ? e.target.value.toUpperCase()
                                            : e.target.value,
                                });
                            }}
                            label={
                                profileState.objective.type &&
                                profileState.objective.type !== ObjectiveDetail.None &&
                                `Please enter ${profileState.objective.type}`
                            }
                            error={!!profileState.errors.objective.value && profileState.submitted}
                            helperText={
                                profileState.submitted && profileState.errors.objective.value
                            }
                            fullWidth
                        />
                    )}
                </Grid>
            </Grid>
        </>
    );
};
